// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__kKEW0","title":"Header_title__x3ga3"};